"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useMinuteBatteryAverage = exports.useMinuteBatteries = exports.useBatteryMinuteLoading = exports.useBatteryMinuteError = exports.useBatteryMinute = void 0;

var _react = require("react");

var _reactRedux = require("react-redux");

var _minuteBattery = require("../reducers/minuteBattery");

var useBatteryMinute = function useBatteryMinute(prospectId, startDate, endDate, baseUrl, authToken) {
  var hasBattery = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
  var dispatch = (0, _reactRedux.useDispatch)();
  var minuteBattery = (0, _reactRedux.useSelector)((0, _minuteBattery.getMinuteBattery)(prospectId, startDate, endDate));
  (0, _react.useEffect)(function () {
    if (prospectId && authToken && baseUrl && hasBattery) {
      dispatch((0, _minuteBattery.fetchMinuteBatteryIfNeeded)(prospectId, startDate, endDate, baseUrl, authToken));
    }
  }, [prospectId, startDate, endDate, baseUrl, authToken, hasBattery]);
  return minuteBattery;
};

exports.useBatteryMinute = useBatteryMinute;

var useMinuteBatteryAverage = function useMinuteBatteryAverage(prospectId, startDate, endDate, baseUrl, authToken) {
  var hasBattery = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
  var batteries = useBatteryMinute(prospectId, startDate, endDate, baseUrl, authToken, hasBattery); // There is an averaged battery

  if (batteries && batteries.length) {
    return batteries.find(function (battery) {
      return battery.isAggregated || battery.serialNumber === 'average';
    });
  }

  return batteries;
};

exports.useMinuteBatteryAverage = useMinuteBatteryAverage;

var useMinuteBatteries = function useMinuteBatteries(prospectId, startDate, endDate, baseUrl, authToken) {
  var hasBattery = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
  var batteries = useBatteryMinute(prospectId, startDate, endDate, baseUrl, authToken, hasBattery);

  if (batteries && batteries.length) {
    return batteries.filter(function (battery) {
      return !battery.isAggregated || battery.serialNumber !== 'average';
    });
  }

  return batteries;
};

exports.useMinuteBatteries = useMinuteBatteries;

var useBatteryMinuteLoading = function useBatteryMinuteLoading() {
  var minuteBatteryLoading = (0, _reactRedux.useSelector)(_minuteBattery.getMinuteBatteryLoading);
  return minuteBatteryLoading;
};

exports.useBatteryMinuteLoading = useBatteryMinuteLoading;

var useBatteryMinuteError = function useBatteryMinuteError() {
  var minuteBatteryError = (0, _reactRedux.useSelector)(_minuteBattery.getMinuteBatteryError);
  return minuteBatteryError;
};

exports.useBatteryMinuteError = useBatteryMinuteError;